import React from 'react';

export const AIAnimationBanner: React.FC = () => {
  return (
    <div className="ai-animation-banner">
      <style>{`
        .ai-animation-banner {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          width: 100%;
          background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
          z-index: 999;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          filter: blur(0.3px);
          -webkit-mask: linear-gradient(to bottom, black 80%, transparent 100%);
          mask: linear-gradient(to bottom, black 80%, transparent 100%);
        }

        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </div>
  );
};